module.exports = __webpack_public_path__ + "img/bs_social-media-data-icon.495be9f0.svg";